import { PaginatedApiClient } from 'api/PaginatedApiClient'
import { sendToApi } from 'api/client'
import { ArticleFlat } from 'types'

export interface MentionArticle {
  created_at: string
  last_edited_at: string
  creator_name: string
  header_emoji: string | null
  id: string
  path: string
  title: string
}

export interface MentionLink {
  href: string
  title: string
  icon: string | undefined
}

export interface MentionUser {
  avatar_url: string | null
  display_name: string
  id: number
}

export enum MentionSort {
  Updated = 'last_edited_at',
  Created = 'created_at',
  AuthorName = 'creator_name',
  Title = 'title',
}

export const MentionClient = {
  getInternalMentionedArticles: (articleId: string, items?: number, sort?: MentionSort) => {
    const sortParams = new URLSearchParams()

    if (sort) sortParams.set('sort', sort)

    return new PaginatedApiClient<{ articles: MentionArticle[] }>(
      `/articles/${articleId}/internal_mentioned_articles?${sortParams.toString()}`,
      { items },
    )
  },
  getInternalMentioningArticles: (articleId: string, items?: number, sort?: MentionSort) => {
    const sortParams = new URLSearchParams()

    if (sort) sortParams.set('sort', sort)

    return new PaginatedApiClient<{ articles: MentionArticle[] }>(
      `/articles/${articleId}/internal_mentioning_articles?${sortParams.toString()}`,
      { items },
    )
  },
  getInternalMentionedUsers: (articleId: string, items?: number) => {
    return new PaginatedApiClient<{ users: MentionUser[] }>(`/articles/${articleId}/internal_mentioned_users`, {
      items,
    })
  },
  getMentionedLinks: (articleId: string, items?: number) => {
    return new PaginatedApiClient<{ links: MentionLink[] }>(`/articles/${articleId}/mentioned_links`, {
      items,
    })
  },

  batchDeleteMentionedUsers: (mentionedUsersIds: string[], articleId: string) => {
    return sendToApi<{ users: MentionUser[] }>(`/articles/${articleId}/internal_mentioned_users/batch_delete`, {
      method: 'DELETE',
      body: {
        mentionedUsersIds: mentionedUsersIds,
      },
    })
  },

  batchDeleteMentionedArticles: (mentionedArticlesIds: string[], articleId: string) => {
    return sendToApi<{ users: MentionUser[] }>(`/articles/${articleId}/internal_mentioned_articles/batch_delete`, {
      method: 'DELETE',
      body: {
        mentionedArticlesIds: mentionedArticlesIds,
      },
    })
  },

  createMentionedArticle: (articleId: string, projectId: string) =>
    sendToApi<ArticleFlat>(`/articles/${articleId}/mentions`, {
      method: 'POST',
      body: {
        project: {
          key: projectId,
        },
      },
    }),

  destroyMentionedArticle: (articleId: string, mentionId: number) =>
    sendToApi<ArticleFlat>(`/articles/${articleId}/mentions/${mentionId}`, {
      method: 'DELETE',
    }),
}
